/* Coccinella gift sections: filter tabs, "who are you giving to" links, and add-to-cart. */
(function () {
  if (window.cocGiftsLoaded) return;
  window.cocGiftsLoaded = true;

  function initCollection(root) {
    if (root.dataset.cocReady) return;
    root.dataset.cocReady = '1';
    var tabs = root.querySelectorAll('[data-coc-tab]');
    var cards = root.querySelectorAll('[data-coc-card]');
    var countEl = root.querySelector('[data-coc-count]');

    function activate(id) {
      var found = false;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-coc-tab') === id;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) found = true;
      });
      if (!found) return false;
      var shown = 0;
      cards.forEach(function (c) {
        var list = ' ' + (c.getAttribute('data-tabs') || '') + ' ';
        var show = id === 'all' || list.indexOf(' ' + id + ' ') > -1;
        c.hidden = !show;
        if (show) shown++;
      });
      if (countEl) countEl.textContent = shown;
      return true;
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-coc-tab')); });
    });
    root.cocActivate = activate;

    // Links like /collections/gift-boxes?gift=love open with that tab selected (handy for emails and ads).
    var wanted = new URLSearchParams(window.location.search).get('gift');
    var fallback = root.getAttribute('data-default-tab');
    if (!(wanted && activate(wanted)) && fallback && fallback !== 'all') activate(fallback);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-coc-collection]').forEach(initCollection);
  }

  // Door cards and buttons with data-coc-filter switch the tab and scroll to the grid.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-coc-filter]');
    if (!link) return;
    var id = link.getAttribute('data-coc-filter');
    var roots = document.querySelectorAll('[data-coc-collection]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].cocActivate && roots[i].cocActivate(id)) {
        e.preventDefault();
        roots[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
        break;
      }
    }
  });

  // Add to cart without leaving the page, then open the Impulse side cart.
  // Never redirects to the cart page. If the side cart is turned off in the theme,
  // the card shows a "View cart" link instead.
  function hasSideCart() {
    var type = window.theme && window.theme.settings && window.theme.settings.cartType;
    return !!document.getElementById('CartDrawer') && type !== 'page';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-coc-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('.coc-add__msg');
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = form.getAttribute('data-adding') || 'Adding…';
    if (msg) msg.textContent = '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (data) {
        var item = data.items ? data.items[0] : data;
        // Same event Impulse's own product forms send: its side cart refreshes and slides open.
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn }, bubbles: true }));
        if (!hasSideCart() && msg) {
          msg.innerHTML = '<a class="coc-link" style="color: var(--coc-ink);" href="' + root + 'cart">' + (form.getAttribute('data-view-cart') || 'View cart') + '</a>';
        }
        btn.innerHTML = form.getAttribute('data-added') || 'Added';
        setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1800);
      })
      .catch(function (err) {
        btn.innerHTML = label;
        btn.disabled = false;
        if (msg) msg.textContent = (err && (err.description || err.message)) || 'Sorry, this box could not be added. Please try again.';
      });
  });

  // Gift box product page: small photos switch the main photo; quantity buttons; option price.
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-coc-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-coc-gallery]');
      var n = thumb.getAttribute('data-coc-thumb');
      gallery.querySelectorAll('[data-coc-slide]').forEach(function (s) { s.hidden = s.getAttribute('data-coc-slide') !== n; });
      gallery.querySelectorAll('[data-coc-thumb]').forEach(function (t) { t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false'); });
      return;
    }
    var step = e.target.closest('[data-coc-qty]');
    if (step) {
      var input = step.closest('.coc-qty').querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-coc-qty')));
    }
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-coc-variant]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var price = select.closest('[data-coc-pdp]').querySelector('[data-coc-price]');
    if (price && option) price.textContent = option.getAttribute('data-price');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Re-run when a section is edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
